module.exports = __webpack_public_path__ + "img/cel.91254816.png";